<template>
    <img
        :src="src"
        :srcset="srcset"
        :alt="alt"
        :src-placeholder="srcPlaceholder"
        :sizes="sizes"
        loading="lazy"
    />
</template>

<script>
export default {
    props: ['src', 'srcset', 'alt', 'srcPlaceholder', 'sizes'],
};
</script>

